import type { DataModelDetail } from '../api/dataModelsService';
import { curateViews } from '../components/business-views/viewCuration.ts';
import { deriveDiscoveryFromViews } from '../components/discover/deriveDiscovery.ts';
import { dataModelDisplayNames } from './dataModelDisplayNames.ts';

/** Resolve discovery labels by exact identifiers without changing the stored model. */
export function dataModelDiscovery(model: Pick<DataModelDetail, 'views' | 'datasets'>) {
  const { views, labels } = dataModelDisplayNames(model);
  return deriveDiscoveryFromViews(curateViews(views), labels);
}